// Typed errors thrown by the api/ HTTP boundary.
//
// Callers pattern-match on these instead of inspecting `Response` objects:
//
//   try { await apiJson("/teams/mine"); }
//   catch (err) {
//     if (err instanceof UnauthorizedError) { /* re-auth */ }
//     else if (err instanceof ApiError) { /* err.status, err.body */ }
//     else { /* network / abort */ }
//   }

export class UnauthorizedError extends Error {
  constructor() {
    super("unauthorized");
    this.name = "UnauthorizedError";
  }
}

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly body: unknown = null,
  ) {
    super(`request failed: ${status}`);
    this.name = "ApiError";
  }
}
